export const KEY = `pk.eyJ1IjoiZm9ybmFsIiwiYSI6ImNtdDJ1bnB4aDB0aDQyeXNnOWxrazJvbm0ifQ.z2NlIhP3CR-yM20f-Yh0vA`
export const RES_PER_PAGE = 20
